import React, { useEffect, useState } from 'react'
import { Box, Button, Typography, Modal, Fab, InputLabel, Autocomplete, TextField } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { useTranslation } from 'react-i18next'
import { ALLOWED_TO_STATES } from './transaction-constants'
import EditIcon from '@mui/icons-material/Edit'
import { useCreateTransactionEventMutation } from '../../../features/transactions/transactionSlice'
import toaster from '../../../toaster'

export default function TransactionStatusModal({ id, currentState, setIsLoading }) {
  const { t } = useTranslation(['common'])
  const [status, setStatus] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [createTransactionEvent, { isLoading: isCreatingEvent }] = useCreateTransactionEventMutation()

  useEffect(() => {
    if (currentState) setStatus(currentState)
  }, [currentState])

  const translateMessage = (errorMessage) => {
    if (errorMessage.includes('NOT_PERMITTED')) {
      toaster.error(`${t('messages:kyt.update.restrictedAccount')}. ${t('messages:kyt.update.contactSupport')}.`, {
        autoClose: 7000,
        closeButton: true,
      })
    } else if (errorMessage.includes('INVALID_STATE')) {
      toaster.error(
        `${t('messages:kyt.update.cantUpdate')} ${t(`common:${currentState}`)} ${t('common:to')} ${t(
          `common:${status}`,
        )}. ${t('messages:kyt.update.contactSupport')}.`,
        {
          autoClose: 7000,
          closeButton: true,
        },
      )
    } else if (errorMessage.includes('MISSING_WEBHOOK')) {
      toaster.error(`${t('messages:kyt.update.missingWebhook')}. ${t('messages:kyt.update.contactSupport')}.`, {
        autoClose: 7000,
        closeButton: true,
      })
    } else {
      toaster.error(errorMessage, {
        autoClose: 7000,
        closeButton: true,
      })
    }
  }

  const handleUpdateStatus = async (id, state) => {
    try {
      await createTransactionEvent({ id, state, currentState }).unwrap()
      setIsLoading(true)

      toaster.success(t('messages:creationSuccess'))
    } catch (err) {
      if (err.data && err.data?.message) {
        translateMessage(err.data.message)
      }
      console.error(err)
    } finally {
      setOpenModal(false)
    }
  }

  return (
    <>
      <Button variant="outlinedButtonSuccess" onClick={() => setOpenModal(true)}>
        <EditIcon />
      </Button>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box className="modal transaction-modal">
          <Box className="modal-top">
            <Box className="modal-titles">
              <Typography variant="title">
                {t('common:edit')} {t('common:transaction')} {t('common:status')}
              </Typography>
            </Box>

            <Fab variant="close" onClick={() => setOpenModal(false)}>
              <CloseOutlinedIcon />
            </Fab>
          </Box>
          <Box className="modal-box">
            <InputLabel>
              {t('common:select')} {t('common:status')}:
            </InputLabel>
            <Autocomplete
              size="small"
              fullWidth
              value={status}
              onChange={(event, value) => setStatus(value)}
              disablePortal
              options={ALLOWED_TO_STATES}
              renderInput={(params) => <TextField {...params} variant="outlined" placeholder={t('common:status')} />}
            />
          </Box>

          <Typography variant="subtitle3">{t('messages:kyt.update.status')}</Typography>

          <Button
            size="small"
            color="secondary"
            variant="contained"
            fullWidth
            onClick={() => handleUpdateStatus(id, status)}
            loading={isCreatingEvent}
            loadingPosition="end"
          >
            {t('common:save')}
          </Button>
        </Box>
      </Modal>
    </>
  )
}
